import * as st from './styles.module.scss';

export const Directions = ({ direction = 'Информация не указана' }: { direction?: string }) => {
  return (
    <div className={st.directions}>
      <h3>Как нас найти</h3>
      <p>{direction}</p>
    </div>
  );
};
